export const detectHolidayIntent = (text: string) => {
    const cleaned = text.toLowerCase().trim();

    /** ----------------------------------
     * DELETE: No name
     * ---------------------------------- */
    if (cleaned === "delete holiday" || cleaned === "remove holiday") {
        return { intent: "delete_holiday" };
    }

    /** ----------------------------------
     * DELETE: With name
     * ---------------------------------- */
    const deleteMatch = cleaned.match(/delete (.+) holiday/);
    if (deleteMatch) {
        return { intent: "delete_holiday", name: deleteMatch[1].trim() };
    }

    /** ----------------------------------
     * CREATE: Without name
     * ---------------------------------- */
    if (cleaned.includes("create holiday") || cleaned.includes("add holiday")) {
        return { intent: "create_holiday" };
    }

    /** ----------------------------------
     * CREATE: With name
     * ---------------------------------- */
    const createMatch = cleaned.match(/create holiday named (.+)/);
    if (createMatch) {
        return { intent: "create_holiday", name: createMatch[1].trim() };
    }

    return null;
};
